import { validColor } from "@/lib/color";
import type { OrgGroup } from "@/lib/types";
import OrgName from "./OrgName";

// 3단: 위원회 — 가로로 나열. desktop 6열(초과 시 가로 스크롤), 모바일 2열 그리드.
// role 과 name 을 «role name» 한 줄로 표기하고, role 이 비면 name 만 표시한다.
export default function OrgCommColumns({ groups }: { groups: OrgGroup[] }) {
  if (groups.length === 0) return null;

  return (
    <div className="grid grid-cols-2 gap-3 md:flex md:gap-4 md:overflow-x-auto md:pb-2">
      {groups.map((g, i) => (
        <div
          key={g.no ?? i}
          className="org-card overflow-hidden rounded-xl border border-background-200 md:min-w-[160px] md:flex-1"
        >
          <div
            className="px-3 py-2.5 text-center text-sm font-bold text-white"
            style={{ backgroundColor: validColor(g.color) ?? "oklch(var(--primary-700))" }}
          >
            {g.name}
          </div>
          <ul className="space-y-2 bg-background-50 px-3 py-3.5">
            {g.members?.map((m, mi) => (
              <li
                key={m.no ?? mi}
                className="flex items-baseline gap-1.5 text-sm leading-snug"
              >
                {m.role ? (
                  <span className="w-14 shrink-0 text-[11px] font-semibold text-foreground-500">
                    {m.role}
                  </span>
                ) : null}
                <OrgName member={m} className="font-medium text-foreground-800" />
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}